import React from 'react';
import { Layout } from '../../components/layout/Layout';
import { PageHero, ContentSection, SEOContent, CTASection } from '../../components/shared';

export const KindervorsorgePage = () => {
  return (
    <Layout>
      <PageHero
        title="Kindervorsorge: Gesunde Entwicklung von Anfang an"
        subtitle="Wir begleiten die gesunde Entwicklung Ihres Kindes von der U3 bis zur J1 mit Sorgfalt und Fachwissen."
        backgroundImage="/images/Kindervorsorge_Hero_opt.webp"
        ctaText="Kindervorsorge-Termin buchen"
      />

      <ContentSection
        title="Schritt für Schritt zu einem gesunden Start"
        content="Die Kindervorsorgeuntersuchungen (U3, U4, U5, U6, U7, U8, U9, J1) sind entscheidend für die frühe Erkennung und Prävention von Entwicklungsstörungen. Wir überwachen die körperliche und geistige Entwicklung Ihres Kindes, führen notwendige Impfungen durch und beraten Sie zu allen Fragen der kindlichen Gesundheit."
        image="/images/2A6_Kindervorsorge.webp"
        backgroundColor="white"
      />

      <SEOContent
        title="Pädiatrische Vorsorgeuntersuchungen in Diez"
        content="Vertrauen Sie auf die Expertise der Gemeinschaftspraxis Dres. von Bergh für die wichtigsten Kindervorsorgeuntersuchungen und die Gesundheitsbegleitung Ihres Nachwuchses."
      />

      <CTASection
        title="Planen Sie die nächste Vorsorgeuntersuchung für Ihr Kind"
        subtitle="Vereinbaren Sie bequem online einen Termin für die Kindervorsorge."
        buttonText="Online-Termin buchen"
      />
    </Layout>
  );
};

export default KindervorsorgePage;
